import React, { useEffect, useState, useId } from 'react'
import styles from './styles.module.css'
import Text from '../../../../../Text'

function InputField({ labelText, value, placeholder, type, required, onChange, multiline, onDoneTyping, autoComplete, name }) {
  const [val, setVal] = useState(value)
  const inputId = useId()

  useEffect(() => {
    onChange(val)

    if (!!onDoneTyping) {
      const timeoutId = setTimeout(() => onDoneTyping(val), 2000)
      return () => clearTimeout(timeoutId)
    }
  }, [val])

  return (
    <div className={styles.inputWrapper}>
      {
        labelText && <label className={styles.label} htmlFor={inputId}>
        <Text type="heading-9">{labelText}</Text>
        </label>
      }
      {
        multiline ?
          <textarea
            className={`${styles.textArea} ${styles.textAreaDark}`}
            id={inputId}
            name={name}
            value={val || ''}
            placeholder={placeholder}
            required={required}
            onChange={(e) => setVal(e.target.value)}
            autoComplete={autoComplete}
          />
          :
          <input
            className={styles.input}
            id={inputId}
            name={name}
            value={val || ''}
            type={type}
            placeholder={placeholder}
            required={required}
            onChange={(e) => setVal(e.target.value)}
            autoComplete={autoComplete}
          />
      }
    </div>
  )
}

export default InputField
